// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/param.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/param.proto.
 */
export const file_agentplatform_v1_param: GenFile = /*@__PURE__*/
  fileDesc("ChxhZ2VudHBsYXRmb3JtL3YxL3BhcmFtLnByb3RvEiNpbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MSLSAwoFUGFyYW0SLAoEdHlwZRgBIAEoCUIeukcbOgoSCCJzdHJpbmcikgIM5Y+C5pWw57G75Z6LEi4KBG5hbWUYAiABKAlCILpHHToMEgoibXlfcGFyYW0ikgIM5Y+C5pWw5ZCN56ewEjMKBnRhcmdldBgDIAEoCUIjukcgOgkSByIkLmZvbyKSAhLmm7/mjaLnm67moIfntKLlvJUSQAoLcmFuZG9tX3R5cGUYBCABKAlCHLpHGToIEgYidXVpZCKSAgzpmo/mnLrnlJ/miJBIAFILcmFuZG9tX3R5cGUSMgoJcmVmZXJlbmNlGAUgASgJQh26Rxo6DxINIm90aGVyX3BhcmFtIpICBuW8leeUqEgAEisKBXZhbHVlGAYgASgJQhq6Rxc6CRIHImhlbGxvIpICCeWPguaVsOWAvEgAEjUKBnNjaGVtYRgHIAEoCUIjukcgOgYSBCJ7fSKSAhXlj4LmlbDlgLwgSlNPTiBTY2hlbWFIABIzCgxjb25maWd1cmFibGUYCCABKAhCHbpHGjoGEgR0cnVlkgIP5Y+C5pWw5Y+v6YWN572uOhi6RxWSAhLmqKHmnb/lj4LmlbDlrprkuYlCDQoLcGFyYW1fdmFsdWVCSVpHZ2l0bGFiLmluZmluaS1haS5jb20vbWl6YXIvaW5maW5pYWktYWdlbnRpYy1pbmZyYS9jb21tb24vZ3JwY2FwaXMvdjE7djFiBnByb3RvMw", [file_gnostic_openapi_v3_annotations]);

/**
 * 模板参数定义
 *
 * @generated from message infinigence.infini.agentplatform.v1.Param
 */
export type Param = Message<"infinigence.infini.agentplatform.v1.Param"> & {
  /**
   * 参数类型
   * @gotags: json:"type,omitempty"
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * 参数名称
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 替换目标索引
   * @gotags: json:"target,omitempty"
   *
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * 参数值类型
   *
   * @generated from oneof infinigence.infini.agentplatform.v1.Param.param_value
   */
  paramValue: {
    /**
     * 随机生成
     * @gotags: json:"random_type,omitempty"
     *
     * @generated from field: string random_type = 4 [json_name = "random_type"];
     */
    value: string;
    case: "randomType";
  } | {
    /**
     * 引用
     * @gotags: json:"reference,omitempty"
     *
     * @generated from field: string reference = 5;
     */
    value: string;
    case: "reference";
  } | {
    /**
     * 参数值
     * @gotags: json:"value,omitempty"
     *
     * @generated from field: string value = 6;
     */
    value: string;
    case: "value";
  } | {
    /**
     * 参数值 JSON Schema
     * @gotags: json:"schema,omitempty"
     *
     * @generated from field: string schema = 7;
     */
    value: string;
    case: "schema";
  } | { case: undefined; value?: undefined };

  /**
   * 参数可配置
   * @gotags: json:"configurable,omitempty"
   *
   * @generated from field: bool configurable = 8;
   */
  configurable: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Param.
 * Use `create(ParamSchema)` to create a new message.
 */
export const ParamSchema: GenMessage<Param> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_param, 0);

